(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/utils.js');
"use strict";


const termsId = svs.trissSubscription.data.config.termsId;
setGlobal('svs.trissSubscription.utils', {
  showSubDialog: _ref => {
    let {
      count,
      price,
      code,
      onComplete
    } = _ref;
    const dialog = new svs.components.dialog.Confirm({
      branding: svs.components.dialog.branding.TUR,
      icon: 'subscription',
      title: 'Starta prenumeration',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: "Vill du best\xE4lla en prenumeration p\xE5 ".concat(count, " st Trisslotter per m\xE5nad f\xF6r ") + "".concat(svs.utils.format.Currency(price * count), " kr/m\xE5n? Prenumerationen betalas i f\xF6rskott och lotterna s\xE4nds ca den 15:e varje m\xE5nad. ") + "F\xF6r prenumerationen av lotter g\xE4ller \xE4ven s\xE4rskilda <a href=\"/dokument/".concat(termsId, "\" target=\"_blank\">prenumerationsvillkor</a>.")
      }],
      actions: [{
        type: svs.components.dialog.button.SECONDARY,
        title: 'Avbryt',
        callback: () => {
          dialog.close();
        }
      }, {
        type: svs.components.dialog.button.PRIMARY,
        title: 'Starta',
        showLoader: true,
        callback: () => {
          svs.trissSubscription.utils.finishSubscription({
            offerCode: code,
            success: () => {
              dialog.close();
              onComplete();
            },
            error: () => {
              const errorDialog = new svs.components.dialog.Confirm({
                branding: svs.components.dialog.branding.TUR,
                icon: 'exclamation-sign',
                type: svs.components.dialog.type.ERROR,
                title: 'Tekniskt fel',
                message: [{
                  type: svs.components.dialog.message.TEXT,
                  text: 'Tekniskt fel, var god försök senare.'
                }],
                actions: [{
                  type: svs.components.dialog.button.SECONDARY,
                  title: 'Ok'
                }]
              });
              svs.components.dialog.api.add(errorDialog);
              dialog.close();
            }
          });
        }
      }]
    });
    svs.components.dialog.api.add(dialog);
  },
  finishSubscription(_ref2) {
    let {
      offerCode,
      success,
      error
    } = _ref2;
    const options = {
      method: 'POST',
      path: '/ticket/1/subscription',
      data: {
        campaignCode: svs.utils.paramHandler.get({
          key: 'kampanj'
        }).value,
        offerCode
      }
    };
    const successFunc = () => {
      if (typeof success === 'function') {
        success();
      }
    };
    const errorFunc = () => {
      if (typeof error === 'function') {
        error();
      }
    };
    svs.core.jupiter.call(options, successFunc, errorFunc);
  },
  getActiveSuspensionsAsync: async () => {
    try {
      const options = {
        method: 'GET',
        path: '/player/1/suspensions'
      };
      const {
        response,
        status
      } = await svs.core.jupiter.callAsync(options);
      if (status && status === 'success') {
        return response.suspensions.filter(suspension => suspension.product === 'quickGames' || suspension.product === 'all');
      }
      return [];
    } catch (error) {
      return [];
    }
  }
});

 })(window);